import { Injectable } from '@angular/core';
import { Machine } from '@shared/entities/machine';
import { ApiService } from '@shared/services';
import { Observable, catchError, map, of } from 'rxjs';

const LOG_PREFIX = '[Api][UserForm] ';

@Injectable({
  providedIn: 'root'
})
export class MachineSFContactIdService extends ApiService<Machine> {
  constructor() {
    const masterUrl = '/machines/sf-contact';
    const detailUrl = '/machines/sf-contact';
    super(Machine, masterUrl, detailUrl);
  }

  getMachinesBySFContactId(sfContactId: string): Observable<Machine[]> {
    this.logger.debug(LOG_PREFIX + `getMachinesBySFContactId with id: ${sfContactId}`);
    this.setUrlParameter('sfContactId', sfContactId);
    return this.paginate(Machine, 1, 100).pipe(
      map((paginate) => {
        return paginate.data || [];
      }),
      catchError((error) => {
        this.logger.error(LOG_PREFIX + 'getMachinesBySFContactId error', error);
        return of([]);
      })
    );
  }
}
